import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "Transmision_title" }, "Histórico de transacciones", -1)
const _hoisted_2 = { class: "table-max" }
const _hoisted_3 = { class: "Table" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "Table_th" }, "Tipo de transacción"),
    /*#__PURE__*/_createElementVNode("th", { class: "Table_th" }, "Fecha"),
    /*#__PURE__*/_createElementVNode("th", { class: "Table_th" }, "Usuario"),
    /*#__PURE__*/_createElementVNode("th", { class: "Table_th" }, "Cantidad documentos"),
    /*#__PURE__*/_createElementVNode("th", { class: "Table_th" }, "Nuevo saldo"),
    /*#__PURE__*/_createElementVNode("th", { class: "Table_th" }, "Operación")
  ])
], -1)
const _hoisted_5 = { class: "Table_td" }
const _hoisted_6 = { class: "Table_td" }
const _hoisted_7 = { class: "Table_td" }
const _hoisted_8 = { class: "Table_td" }
const _hoisted_9 = { class: "Table_td" }
const _hoisted_10 = { class: "Table_td icono-transaccion" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_Spinner = _resolveComponent("Spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.storyPlan, (item) => {
            return (_openBlock(), _createElementBlock("tr", { key: item }, [
              _createElementVNode("td", _hoisted_5, _toDisplayString(item.operacionNombre), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(_ctx.normalizeDateValidator(item.fecha)), 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(item.usuario), 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.normalizeNumberValidator(item.cantidadDocumentos)), 1),
              _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.normalizeNumberValidator(item.nuevoSaldo)), 1),
              _createElementVNode("td", _hoisted_10, [
                (item.operacion == 1)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "plus-circle"
                    }))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: "minus-circle"
                    }))
              ])
            ]))
          }), 128))
        ])
      ]),
      _createElementVNode("input", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.GoToPlanControl())),
        type: "button",
        value: "Regresar",
        class: "Button_BColorDegraded Button_fontButtonError"
      })
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Spinner, {
          key: 0,
          type: "modern"
        }))
      : _createCommentVNode("", true)
  ], 64))
}